import { getSignupFormSchema } from "@redotech/redo-model/marketing/schemas/get-signup-form-schema";
import { WidgetAutocheck } from "@redotech/redo-model/widget";

export function initialize(autocheck: WidgetAutocheck) {
  console.log(getSignupFormSchema);
}
